import { Button, Card, SimpleGrid } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useRequirementFormContext } from '../ClientIppSection';
import { isEmptyForm } from '@/utils/functions';

export const DaySelectorCard = ({
  days,
  repetition,
}: {
  days: number[];
  repetition: string;
}): JSX.Element => {
  const daysInMonth = 31;
  const numbersList = Array.from(
    { length: daysInMonth },
    (_, index) => index + 1
  );
  const requirementForm = useRequirementFormContext();
  const [selectedDays, setSelectedDays] = useState<number[]>(days);

  const handleButtonClick = (number: number): void => {
    if (selectedDays.includes(number)) {
      setSelectedDays(selectedDays.filter(selected => selected !== number));
    } else {
      setSelectedDays([...selectedDays, number]);
    }
  };

  useEffect(() => {
    if (
      !isEmptyForm(requirementForm) &&
      repetition !== '0' &&
      requirementForm.values.recur?.freq === 'MONTHLY'
    ) {
      requirementForm.setFieldValue('recur.byMonthDay', selectedDays);
    }
  }, [selectedDays]);

  return (
    <Card withBorder mt="xs">
      <SimpleGrid cols={7} verticalSpacing="xs" spacing="xs">
        {numbersList.map(element => (
          <Button
            size="sm"
            variant={selectedDays.includes(element) ? 'filled' : 'default'}
            key={element}
            onClick={() => handleButtonClick(element)}
          >
            {element}
          </Button>
        ))}
      </SimpleGrid>
    </Card>
  );
};
